import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './AguardandoPagamento.module.css';

function AguardandoPagamento() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mensagem, setMensagem] = useState('Aguardando confirmação do pagamento...');
  const [verificando, setVerificando] = useState(true);

  useEffect(() => {
    // Pega a referência da URL ou do localStorage
    const params = new URLSearchParams(location.search);
    const refFromURL = params.get('ref');
    const reference = refFromURL || localStorage.getItem('payment_reference');

    if (!reference) {
      setMensagem('Referência de pagamento não encontrada.');
      setVerificando(false);
      setTimeout(() => navigate('/carrinho'), 3000);
      return;
    }

    const API_URL = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');
    let intervalId;

    // Função para verificar o status do pagamento
    const verificarPagamento = async () => {
      try {
        const response = await fetch(`${API_URL}/verificar-pagamento/${reference}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();
        console.log('Status do pagamento:', result);

        if (result.status === 'aprovado') {
          // Pagamento aprovado! Limpar dados e redirecionar
          clearInterval(intervalId);
          setVerificando(false);
          setMensagem('Pagamento confirmado! Redirecionando...');

          // Limpar carrinho e dados temporários
          localStorage.removeItem('carrinho');
          localStorage.removeItem('tipoEntrega');
          localStorage.removeItem('dataAgendada');
          localStorage.removeItem('horaAgendada');
          localStorage.removeItem('payment_reference');

          // Armazenar código de entrega temporariamente
          localStorage.setItem('ultimo_codigo_entrega', result.codigo_entrega);

          setTimeout(() => {
            navigate('/sucesso');
          }, 2000);

        } else if (result.status === 'nao_encontrado') {
          clearInterval(intervalId);
          setVerificando(false);
          setMensagem('Pagamento não encontrado. Redirecionando ao carrinho...');
          setTimeout(() => navigate('/carrinho'), 3000);

        } else {
          // Ainda aguardando
          setMensagem('Aguardando confirmação do pagamento...');
        }

      } catch (error) {
        console.error('Erro ao verificar pagamento:', error);
        setMensagem('Erro ao verificar pagamento. Tentando novamente...');
      }
    };

    // Verifica imediatamente ao carregar
    verificarPagamento();

    // Depois verifica a cada 3 segundos
    intervalId = setInterval(verificarPagamento, 3000);

    // Cleanup: para o intervalo quando o componente desmontar
    return () => {
      if (intervalId) clearInterval(intervalId);
    };

  }, [location, navigate]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconContainer}>
          {verificando ? (
            <div className={styles.spinner}></div>
          ) : (
            <svg
              className={styles.checkIcon}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          )}
        </div>

        <h1 className={styles.titulo}>{mensagem}</h1>

        {verificando && (
          <>
            <p className={styles.descricao}>
              Estamos verificando o status do seu pagamento no PagSeguro.
            </p>
            <p className={styles.descricao}>
              Isso pode levar alguns segundos. Por favor, aguarde...
            </p>
          </>
        )}

        <div className={styles.infoBox}>
          <p className={styles.infoText}>
            💡 <strong>Dica:</strong> Se você já realizou o pagamento, aguarde a confirmação.
            O processo é automático!
          </p>
        </div>
      </div>
    </div>
  );
}

export default AguardandoPagamento;
